import PropTypes from 'prop-types';
import React from 'react';
import cN from 'classnames';

import 'materialize-css/js/waves';
import LoadingIndicator from './LoadingIndicator';

/**
 * Renders a button with a materialize wave effect.
 */

const Button = ({tag: Tag, type, className, waveEffect, children, disabled, flat, large, floating, fixed, horizontal,
                    actions, clickToToggle, loading, ...props}) => {
    const button = (
        <Tag
            className={cN('btn', className, {
                'waves-effect': waveEffect,
                [`waves-${waveEffect}`]: waveEffect,
                'btn-large': large,
                'btn-floating': floating,
                'btn-flat': flat,
            })}
            type={type}
            disabled={disabled}
            {...props}
        >
            {loading && <LoadingIndicator />}
            {children}
        </Tag>
    );

    return (
        fixed ? (
            <div className={cN('fixed-action-btn', {horizontal, 'click-to-toggle': clickToToggle})}>
                {button}
                {actions && <ul>{actions.map(action => <li>{action}</li>)}</ul>}
            </div>
        ) : button
    );
};

Button.propTypes = {
    tag: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    type: PropTypes.oneOf([
        'button',
        'submit',
    ]),
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    waveEffect: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.oneOf([
            'light',
            'red',
            'yellow',
            'orange',
            'purple',
            'green',
            'teal',
        ]),
    ]),
    disabled: PropTypes.bool,
    flat: PropTypes.bool,
    large: PropTypes.bool,
    floating: PropTypes.bool,
    fixed: PropTypes.bool,
    horizontal: PropTypes.bool,
    actions: PropTypes.arrayOf(PropTypes.instanceOf(Button)),
    clickToToggle: PropTypes.bool,
    loading: PropTypes.bool,
};

Button.defaultProps = {
    tag: 'button',
    waveEffect: null,
    className: undefined,
    type: 'button',
    disabled: false,
    flat: false,
    large: false,
    floating: false,
    fixed: false,
    horizontal: false,
    actions: null,
    clickToToggle: false,
    loading: false,
};

export default Button;



// WEBPACK FOOTER //
// ./scripts/components/Button.js